import { fromJS } from 'immutable'
import {
  SUBCONTRACT_COST_CREATE_REQUEST,
  SUBCONTRACT_COST_CREATE_SUCCESS,
  SUBCONTRACT_COST_CREATE_FAILURE,
  SUBCONTRACT_COST_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SUBCONTRACT_COST_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case SUBCONTRACT_COST_CREATE_SUCCESS:
      return state
        .set('createdSubcontractCostMaster', fromJS(action.payload.createdSubcontractCostMaster))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case SUBCONTRACT_COST_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdSubcontractCostMaster', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case SUBCONTRACT_COST_CREATE_RESET:
      return state
        .delete('createdSubcontractCostMaster')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subcontract-cost/subcontract-cost-create-reducer.js